import Maincomponent from "./Main";
import Stats from "./Stats";
import Classes from "./Сlasses";
import Sclass from "./Сlass";
import Trainers from './Trainers'
import Trainer from './../trainer/trainer'
import Homework from './Homework'
import Lessons from './Lessons'
import Materials from './Materials'
import Scores from './Scores'
import Rtime from './rt'
import Info from './Info'
import Shop from './shop/Index'
import FirstAnketa from './FirstAnketa'

//конкурсы
import DrawContest from '../contests/draw_contest/DrawContest'
import Matrius from '../contests/matrius/Matrius'

export default [
  { path: '/', component: Maincomponent },
  { path: '/stats', component: Stats },
  { path: '/classes', component: Classes },
  { path: '/rt', component: Rtime },
  { path: '/class/:id', component: Sclass },
  { path: '/trainers', component: Trainers },
  { path: '/scores', component: Scores },
  { path: '/shop', component: Shop },
  { path: '/access-denied', component: Info },
  { path: '/lessons', component: Lessons },
  { path: '/materials', component: Materials },
  { path: '/first-anketa', component: FirstAnketa },
  { name: 'student_homework', path: '/homework', component: Homework },
  { name: 'trainer', path: '/trainer/:component', component: Trainer, params: true },

  // { path: '/draw-contest', component: DrawContest },
  { path: '/matrius', component: Matrius },
];